<div [class]="showWhiteHeaderBackground === true ? 'desktop-detail-view_new' : 'desktop-detail-view'">
  <div [class]="showWhiteHeaderBackground === true ? 'desktop-detail-view__header_new' : 'desktop-detail-view__header'">
    <ng-content select="itl-desktop-detail-view-header"></ng-content>
  </div>
  <div class="desktop-detail-view__content">
    <ng-content></ng-content>
  </div>
</div>
